export const initialState = {
  isAddUserModalOpened: false,
  addUserModalProps: {},
};

export const reducer = (state = initialState, { type, value }) => {
  switch (type) {
    case "OPEN_ADD_USER_MODAL":
      return { isAddUserModalOpened: true, addUserModalProps: value };
    case "CLOSE_ADD_USER_MODAL":
      return { isAddUserModalOpened: false, addUserModalProps: {} };
    default:
      return state;
  }
};
export default reducer;
